import * as React from 'react';

import { palette, Tag } from 'app2/components'

export function OptionalCourseTag() {
  return <Tag bg={palette.secondary.blue.hex} height='fit-content' color='primaryInverse'>Option</Tag>
}